<template lang="pug">
	.book(v-bind:class="openClass" v-touch:swipe.left="onClick")
		ul.hardcover-front
			li
				.cover-design
					logo(:click-event="false")
					h1 The Hukopedia
					//-.warning-box
						.warning-title
							| Warning
						| This compendium acknowledges that sexuality and reproduction are part of life. Also be aware that human morality and taboos may not apply to the Hukos. If this concerns you, perhaps you should leave.
					.button-box
						button-themed(@click="onClick" spaced) Open
			li
</template>

<script>
import Logo from '@/components/Logo'
import ButtonThemed from '@/components/ButtonThemed'

export default {
	name      : 'HardCover',
	components: {
		Logo,
		ButtonThemed
	},
	data () {
		return {
			active: false
		}
	},
	computed: {
		openClass () {
			return { 'is-active': this.active }
		}
	},
	methods: {
		onClick () {
			if (!this.active) {
				this.active = true
				this.$emit('opening')
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
	$cover-color = #eee
	$cover-back-color = #fffbec
	$cover-border-color = #999

	.book
		position relative
		z-index 12
		height 100%
		width 100%
		perspective 1000px
		transform-style: preserve-3d

	.hardcover-front
		list-style none
		margin 0
		padding 0
		height 100%
		width 100%

		li:first-child
			background-color $cover-color
			backface-visibility hidden
			cursor default
			transform translateZ(3px)
			box-shadow 0px 0px 20px 10px rgba(0,0,0,0.8)

		li:last-child
			background-color $cover-back-color
			transition transform 0.8s ease, opacity 1.0s ease
			opacity 1
			transform rotateY(180deg) translateZ(2px)

		li:first-child:after,
		li:first-child:before,
		li:last-child:before
			content ''
			background $cover-border-color
			position absolute
			top 0
			bottom 0
			width 4px

		li:first-child:before,
		li:last-child:before
			left 0

		li:first-child:after
			right 0

		.cover-design
			position absolute
			top 0
			left 0
			bottom 0
			right 0
			display flex
			justify-content center
			align-items center
			flex-direction column
			overflow hidden
			backface-visibility hidden

			img:first-child
				margin-top 3vmin
				margin-bottom 2rem
				width 12rem

				@media (max-width: 649px)
					margin-top 1rem
					margin-bottom 1rem
					width 7rem

				@media (max-height: 799px)
					width 8rem

				@media (max-height: 699px)
					margin-top 1rem
					margin-bottom 1rem
					width 7rem

			.button-box
				margin-bottom 5rem

				@media (max-width: 649px)
					margin-bottom 1rem

	.hardcover-front,
	.hardcover-front li
		position absolute
		top 0
		left 0
		bottom 0
		width 100%
		transform-style preserve-3d

	.hardcover-front
		transform rotateY(-5deg) translateZ(2px)
		transform-origin 0% 100%
		transition all 2s ease, z-index 0.6s

	.book.is-active .hardcover-front
		transform rotateY(-180deg)

		li:last-child
			transform rotateY(180deg) translateZ(0px)

</style>
